import { Homepage as HomepageAdmin } from "./pages/Admin/Homepage";
import { OrganizationRegistration as OrganizationRegistrationAdmin } from "./pages/Admin/OrganizationRegistration";
import { YEKGCommitmentStatus as YEKGCommitmentStatusAdmin } from "./pages/Admin/YEKGCommitmentStatus";
import { YEKGParticipation as YEKGParticipationAdmin } from "./pages/Admin/YEKGParticipation";
import { InvoiceColletarelReport as InvoiceColletarelReportAdmin } from "./pages/Admin/CollateralOperations";
import { IntraSeanceCollateral as IntraSeanceCollateralAdmin } from "./pages/Admin/CollateralOperations";

import {
  OfferOperations as OfferOperationsAdmin,
  MarketResults as MarketResultsAdmin,
  OffersAndMatches as OffersAndMatchesAdmin,
  BilateralAgreements as BilateralAgreementsAdmin,
  BilateralAgreementOperations as BilateralAgreementOperationsAdmin,
  Objections as ObjectionsAdmin,
} from "./pages/Admin/OrganizedMarket";
import {
  ActiveCertificates as ActiveCertificatesAdmin,
  SuspendedCertificates as SuspendedCertificatesAdmin,
  CanceledCertificates as CanceledCertificatesAdmin,
  GDDKOperations as GDDKOperationsAdmin,
} from "./pages/Admin/Certificates";
import { ExportTransactions as ExportTransactionsAdmin } from "./pages/Admin/ExportTransactions";
import {
  RedemptionOperations as RedemptionOperationsAdmin,
  RedemptionOperationsHistory as RedemptionOperationsHistoryAdmin,
} from "./pages/Admin/Redemption";
import { SystemParameters as SystemParametersAdmin } from "./pages/Admin/SystemParameters";
import { Reconciliation as ReconciliationAdmin } from "./pages/Admin/Reconciliation";
import { Invoicing as InvoicingAdmin } from "./pages/Admin/Invoicing";
import { OperationHistory as OperationHistoryAdmin } from "./pages/Admin/OperationHistory";
import { Notifications as NotificationsAdmin } from "./pages/Admin/Notifications";
import { Homepage as HomepageSystemParticipant } from "./pages/SystemParticipant/Homepage";
import {
  OfferOperations as OfferOperationsSystemParticipant,
  MarketResults as MarketResultsSystemParticipant,
  OffersAndMatches as OffersAndMatchesSystemParticipant,
  BilateralAgreements as BilateralAgreementsSystemParticipant,
  BilateralAgreementOperations as BilateralAgreementOperationsSystemParticipant,
  Objections as ObjectionsSystemParticipant,
} from "./pages/SystemParticipant/OrganizedMarket";
import {
  ActiveCertificates as ActiveCertificatesSystemParticipant,
  SuspendedCertificates as SuspendedCertificatesSystemParticipant,
  CanceledCertificates as CanceledCertificatesSystemParticipant,
  GDDKOperations as GDDKOperationsSystemParticipant,
} from "./pages/SystemParticipant/Certificates";
import { ExportTransactions as ExportTransactionsSystemParticipant } from "./pages/SystemParticipant/ExportTransactions";
import {
  RedemptionOperations as RedemptionOperationsSystemParticipant,
  RedemptionOperationsHistory as RedemptionOperationsHistorySystemParticipant,
} from "./pages/SystemParticipant/Redemption";
import { Reconciliation as ReconciliationSystemParticipant } from "./pages/SystemParticipant/Reconciliation";
import { Invoicing as InvoicingSystemParticipant } from "./pages/SystemParticipant/Invoicing";
import { SystemParameters as SystemParametersSystemParticipant } from "./pages/SystemParticipant/SystemParameters";
import { OperationHistory as OperationHistorySystemParticipant } from "./pages/SystemParticipant/OperationHistory";
import { UserParameters as UserParametersSystemParticipant } from "./pages/SystemParticipant/UserParameters";
import { UserParameters as UserParametersAdmin } from "./pages/Admin/UserParameters";
import { SystemParticipantNotAllowed } from "./layouts";

import { Notifications as NotificationsSystemParticipant } from "./pages/SystemParticipant/Notifications";
import { NotificationSettings as NotificationSettingsSystemParticipant } from "./pages/SystemParticipant/Notifications";

//Collaterals
import {
  InvoiceColletarelReport as InvoiceColletarelReportSystemParticipant,
  IntraSeanceCollateral as IntraSeanceCollateralSystemParticipant,
} from "./pages/SystemParticipant/CollateralOperations";
// JOBS
import JOBS from "./pages/Admin/Jobs/JOBS";
import { Collateral } from "./pages/Admin/Collateral";

const routes = {
  admin: [
    {
      path: "/",
      exact: true,
      permissions: ["YEKG041", "YEKG042"],
      component: (props) => HomepageAdmin(props),
    },
    {
      path: "/organization-registration",
      exact: true,
      permissions: ["YEKG045", "YEKG046"],
      component: (props) => OrganizationRegistrationAdmin(props),
    },
    {
      path: "/yekg-commitment-status-list",
      exact: true,
      permissions: ["YEKG045", "YEKG046"],
      component: (props) => YEKGCommitmentStatusAdmin(props),
    },
    {
      path: "/yekg-participation-list",
      exact: true,
      permissions: ["YEKG045", "YEKG046"],
      component: (props) => YEKGParticipationAdmin(props),
    },
    {
      path: "/offer-operations",
      exact: true,
      permissions: ["YEKG007", "YEKG008"],
      component: (props) => OfferOperationsAdmin(props),
    },
    {
      path: "/market-results",
      exact: true,
      permissions: ["YEKG011", "YEKG012"],
      component: (props) => MarketResultsAdmin(props),
    },
    {
      path: "/offers-and-matches",
      exact: true,
      permissions: ["YEKG009", "YEKG010"],
      component: (props) => OffersAndMatchesAdmin(props),
    },
    {
      path: "/bilateral-agreements",
      exact: true,
      permissions: ["YEKG003", "YEKG004"],
      component: (props) => BilateralAgreementsAdmin(props),
    },
    {
      path: "/bilateral-agreement-operations",
      exact: true,
      permissions: ["YEKG005", "YEKG006"],
      component: (props) => BilateralAgreementOperationsAdmin(props),
    },
    {
      path: "/objections",
      exact: true,
      permissions: ["YEKG013", "YEKG014"],
      component: (props) => ObjectionsAdmin(props),
    },
    {
      path: "/active-certificates",
      exact: true,
      permissions: ["YEKG015", "YEKG016"],
      component: (props) => ActiveCertificatesAdmin(props),
    },
    {
      path: "/suspended-certificates",
      exact: true,
      permissions: ["YEKG017", "YEKG018"],
      component: (props) => SuspendedCertificatesAdmin(props),
    },
    {
      path: "/canceled-certificates",
      exact: true,
      permissions: ["YEKG019", "YEKG020"],
      component: (props) => CanceledCertificatesAdmin(props),
    },
    {
      path: "/gddk-operations",
      exact: false,
      permissions: ["YEKG029", "YEKG030", "YEKG031", "YEKG032"],
      component: (props) => GDDKOperationsAdmin(props),
    },
    {
      path: "/export-transactions",
      exact: true,
      permissions: ["YEKG021", "YEKG022"],
      component: (props) => ExportTransactionsAdmin(props),
    },
    {
      path: "/redemption-operations",
      exact: true,
      permissions: ["YEKG023", "YEKG024", "YEKG025", "YEKG026"],
      component: (props) => RedemptionOperationsAdmin(props),
    },
    {
      path: "/redemption-operations-history",
      exact: true,
      permissions: ["YEKG027", "YEKG028"],
      component: (props) => RedemptionOperationsHistoryAdmin(props),
    },
    {
      path: "/system-parameters",
      exact: true,
      permissions: ["YEKG037", "YEKG038"],
      component: (props) => SystemParametersAdmin(props),
    },
    {
      path: "/reconciliation",
      exact: true,
      permissions: ["YEKG033", "YEKG034"],
      component: (props) => ReconciliationAdmin(props),
    },
    {
      path: "/invoicing",
      exact: true,
      permissions: ["YEKG035", "YEKG036"],
      component: (props) => InvoicingAdmin(props),
    },
    {
      path: "/operation-history",
      exact: true,
      permissions: ["YEKG039", "YEKG040"],
      component: (props) => OperationHistoryAdmin(props),
    },
    {
      path: "/user-parameters",
      exact: true,
      permissions: ["YEKG039", "YEKG040"],
      component: (props) => UserParametersAdmin(props),
    },
    {
      path: "/notifications",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => NotificationsAdmin(props),
    },
    {
      path: "/run-jobs",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => JOBS(props),
    },
    {
      path: "/collateral-table",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => Collateral(props),
    },
    {
      path: "/intra-seance-collateral",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => IntraSeanceCollateralAdmin(props),
    },
    {
      path: "/invoice-colletarel-report",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => InvoiceColletarelReportAdmin(props),
    },
  ],
  systemParticipant: [
    {
      path: "/",
      exact: true,
      permissions: ["YEKG041", "YEKG042"],
      component: (props) => HomepageSystemParticipant(props),
    },
    {
      path: "/offer-operations",
      exact: true,
      permissions: ["YEKG007", "YEKG008"],
      component: (props) => OfferOperationsSystemParticipant(props),
    },
    {
      path: "/offers-and-matches",
      exact: true,
      permissions: ["YEKG009", "YEKG010"],
      component: (props) => OffersAndMatchesSystemParticipant(props),
    },
    {
      path: "/market-results",
      exact: true,
      permissions: ["YEKG011", "YEKG012"],
      component: (props) => MarketResultsSystemParticipant(props),
    },
    {
      path: "/bilateral-agreements",
      exact: true,
      permissions: ["YEKG003", "YEKG004"],
      component: (props) => BilateralAgreementsSystemParticipant(props),
    },
    {
      path: "/bilateral-agreement-operations",
      exact: true,
      permissions: ["YEKG005", "YEKG006"],
      component: (props) =>
        BilateralAgreementOperationsSystemParticipant(props),
    },
    {
      path: "/objections",
      exact: true,
      permissions: ["YEKG013", "YEKG014"],
      component: (props) => ObjectionsSystemParticipant(props),
    },
    {
      path: "/active-certificates",
      exact: true,
      permissions: ["YEKG015", "YEKG016"],
      component: (props) => ActiveCertificatesSystemParticipant(props),
    },
    {
      path: "/suspended-certificates",
      exact: true,
      permissions: ["YEKG017", "YEKG018"],
      component: (props) => SuspendedCertificatesSystemParticipant(props),
    },
    {
      path: "/canceled-certificates",
      exact: true,
      permissions: ["YEKG019", "YEKG020"],
      component: (props) => CanceledCertificatesSystemParticipant(props),
    },
    {
      path: "/gddk-operations",
      exact: false,
      permissions: ["YEKG029", "YEKG030", "YEKG031", "YEKG032"],
      component: (props) => GDDKOperationsSystemParticipant(props),
    },
    {
      path: "/export-transactions",
      exact: true,
      permissions: ["YEKG021", "YEKG022"],
      component: (props) => ExportTransactionsSystemParticipant(props),
    },
    {
      path: "/redemption-operations",
      exact: true,
      permissions: ["YEKG023", "YEKG024", "YEKG025", "YEKG026"],
      component: (props) => RedemptionOperationsSystemParticipant(props),
    },
    {
      path: "/redemption-operations-history",
      exact: true,
      permissions: ["YEKG027", "YEKG028"],
      component: (props) => RedemptionOperationsHistorySystemParticipant(props),
    },
    {
      path: "/reconciliation",
      exact: true,
      permissions: ["YEKG033", "YEKG034"],
      component: (props) => ReconciliationSystemParticipant(props),
    },
    {
      path: "/invoicing",
      exact: true,
      permissions: ["YEKG035", "YEKG036"],
      component: (props) => InvoicingSystemParticipant(props),
    },
    {
      path: "/system-parameters",
      exact: false,
      permissions: ["YEKG037", "YEKG038"],
      component: (props) => SystemParametersSystemParticipant(props),
    },
    {
      path: "/operation-history",
      exact: true,
      permissions: ["YEKG039", "YEKG040"],
      component: (props) => OperationHistorySystemParticipant(props),
    },
    {
      path: "/user-parameters",
      exact: true,
      permissions: ["YEKG039", "YEKG040"],
      component: (props) => UserParametersSystemParticipant(props),
    },
    {
      path: [
        "/SystemParticipantNotAllowed",
        "/active-certificates-notAllowed",
        "/suspended-certificates-notAllowed",
        "/redemption-operations-notAllowed",
        "/canceled-certificates-notAllowed",
        "/export-transactions-notAllowed",
        "/bilateral-agreements-notAllowed",
        "/offer-operations-notAllowed",
      ],
      exact: true,
      permissions: ["YEKG039", "YEKG040"],
      component: (props) => SystemParticipantNotAllowed(props),
    },
    {
      path: "/notifications",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => NotificationsSystemParticipant(props),
    },
    {
      path: "/notification-settings",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => NotificationSettingsSystemParticipant(props),
    },
    {
      path: "/intra-seance-collateral",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => IntraSeanceCollateralSystemParticipant(props),
    },
    {
      path: "/invoice-colletarel-report",
      exact: true,
      permissions: ["YEKG043", "YEKG044"],
      component: (props) => InvoiceColletarelReportSystemParticipant(props),
    },
  ],
};
export default routes;
